import React from "react";
import { formValues } from 'redux-form';

const Header = ({formValues, user, address}) => {
  return (
    <div className="coming-soon header page-section header-section">
      <div className="export-header coming_soon-export-header">
        <div className="coming__soon-contact-name">
          <div className="header-top">
            <div className="editable">Coming Soon</div>
            <div>
              {formValues &&
              formValues.branding &&
              formValues.branding === "mylogo" &&
              user &&
              user.logo ? (
                <img className="header-logo" src={user.logo} />
              ) : null}
            </div>
           
          </div>
          <div className="comp-address-top editable">{address}</div>       
        </div>
      </div>
    </div>
  );
};


export default Header;
